import React from 'react'
import '../App.css'

export default function about() {
    return (
        <h1 className="about">
          ABOUT
        </h1>
    )
}
